import Service from '@ember/service';

// Logging Service: Centralizes logging for the application so we can filter it or direct it as we please.

// It's what this service *does* :)
export default class LoggingService extends Service {
  log() {
    console.log(...arguments);
  }
  info() {
    console.info(...arguments);
  }
  warn() {
    console.warn(...arguments);
  }
  error() {
    console.error(...arguments);
  }
  time() {
    console.time(...arguments);
  }
  timeEnd() {
    console.timeEnd(...arguments);
  }
}
